// extracted by mini-css-extract-plugin
module.exports = {"container":"Pill_container__3Se4J","minus":"Pill_minus__3RYkD","plus":"Pill_plus__2MspI","input":"Pill_input__1WuI9"};